import LocationsAdd from 'modules/Admin/locations/LocationsAdd'

function LocationsCreatePage() {
  return (
    <div data-testid="adminLocationsCreatePage">
      <LocationsAdd />
    </div>
  )
}

export default LocationsCreatePage
